import { twMerge } from "tailwind-merge"

const sectionCX =
  "bg-brand-green-darker z-20 items-center text-center text-white font-base lg:flex hidden p-2"
const paragraphCX = "xl:text-[.9em] text-xs w-full"

// export const ReleaseBanner = () => {
//   return (
//     <section className={sectionCX}>
//       <p className={paragraphCX}>
//         <span className="font-bold">FEATURE UPDATE!</span> Tree Equity Score 'Reports' are now
//         'Location Insights.' All the features you know and love are still here, along with fresh
//         insights, visuals, and never-before-seen data in this supercharged toolkit. Learn more{" "}
//         <a
//           href={`${STATIC_ASSETS_CLOUDFRONT_URL}/TreeEquityScoreLocationInsights_GetStartedGuide.pdf`}
//           target="_blank"
//           rel="noreferrer noopener"
//           className="underline"
//         >
//           here.
//         </a>
//       </p>
//     </section>
//   )
// }

export const PRVIReleaseBanner = ({ lng }: { lng: "en" | "es" }) => {
  const copy =
    lng === "en"
      ? [
          "NEW! Tree Equity Scores are now available for Puerto Rico and the U.S. Virgin Islands in the National Explorer.",
          "¡Novedad! El Índice de Equitatividad Arbórea ya está disponible para Puerto Rico y las Islas Vírgenes de los EE. UU. en el Mapa Nacional.",
        ]
      : [
          "¡Novedad! El Índice de Equitatividad Arbórea ya está disponible para Puerto Rico y las Islas Vírgenes de los EE. UU. en el Mapa Nacional.",
        ]
  return (
    <section className={twMerge(sectionCX, "flex flex-col")}>
      {copy.map((text, index) => (
        <p className={paragraphCX} key={index}>
          {text}
        </p>
      ))}
    </section>
  )
}

export const PRVIMapBanner = ({ lng }: { lng: "en" | "es" }) => {
  const copy =
    lng === "en"
      ? ["NEW! Tree Equity Scores are now available for Puerto Rico and the U.S. Virgin Islands."]
      : [
          "¡Novedad! El Índice de Equitatividad Arbórea ya está disponible para Puerto Rico y las Islas Vírgenes de los EE. UU.",
        ]
  return (
    <section className={twMerge(sectionCX, "flex flex-col")}>
      {copy.map((text, index) => (
        <p className={paragraphCX} key={index}>
          {text}
        </p>
      ))}
    </section>
  )
}

export const WashingtonTESABanner = () => {
  return (
    <section className={sectionCX}>
      <p className={paragraphCX}>
        <span className="font-bold">NEW!</span>{" "}
        <a
          href="/analyzer/washington#resources"
          target="_blank"
          rel="noreferrer noopener"
          className="underline"
        >
          Learn more here
        </a>{" "}
        about forest health in Washington State and how to get involved today.
      </p>
    </section>
  )
}
